
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gnapXH8EQFZJlJiTp0h7UfFGV0_Gq6Ast49MDhZddATsMeta } from "/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexdgoqSPUgT0VuO6E8twJRp_OZTDgAc8wSb7WEQhRgtDkMeta } from "/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchEkKtVnBq_45hR1_T5_45OKIRv05Mw1q1_ch5m9WljdRiSsUMeta } from "/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexfDPRX1uuW0GtqLcM2wBfnF3FtwMMAbcu05R6mIlZYoUMeta } from "/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93sJZIaN_4522yZLhwcK1mXh6lCxBJPjUHkGMSgip5gv_45WEMeta } from "/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexAcjI8aTt_45451rukQaGlFaMnas1n2aQQdXJCv4iCgucMMeta } from "/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93woxPUB_45WTGn66SLFzk5FNpulKkZserW9uP7o7UWCvIgMeta } from "/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index8U0jd3gERUyvJhdxQbmTPQM75a6vTfiz6U4uu_45sZbjEMeta } from "/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_930Nv4mRZKmq_45UEsTf3v3sfhjjz2nt3EsmL1_3S8DkOzcMeta } from "/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexTnR76ZiY_45_mQil6BvtWfycngp9q0qoxlIogw1JkScMcMeta } from "/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexVgvgz_ExJ2agnGc9SyhxyeLDjQX_45tFWH_gYV0KKt5bQMeta } from "/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexAcjI8aTt_45451rukQaGlFaMnas1n2aQQdXJCv4iCgucMMeta || {},
    component: () => import("/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index8U0jd3gERUyvJhdxQbmTPQM75a6vTfiz6U4uu_45sZbjEMeta || {},
    component: () => import("/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexTnR76ZiY_45_mQil6BvtWfycngp9q0qoxlIogw1JkScMcMeta || {},
    component: () => import("/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexVgvgz_ExJ2agnGc9SyhxyeLDjQX_45tFWH_gYV0KKt5bQMeta || {},
    component: () => import("/codebuild/output/src3956828485/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]